import Image from 'next/image';
import loading from '@/public/static/images/loading.svg';


const PageLoadingMessage = ({ message }) => (
  <div className="has-text-centered" style={{padding: '8rem'}}>
    <figure className="icon" style={{height: '6rem', width: '6rem'}}>
      <Image alt="loading indicator" src={loading.src} layout="intrinsic" height={100} width={100} />
    </figure>
    <p>{message}</p>
  </div>
);

export default PageLoadingMessage;
